<template>
  <input
    type="text"
    class="form-control"
    ref="input"
    v-model="date"
  >
</template>

<script>
  import $ from 'jquery'
  import moment from 'moment'
  import eve from 'dom-events'
  import 'bootstrap-datepicker'
  import 'bootstrap-datepicker/js/locales/bootstrap-datepicker.ru'

  $.fn.datepicker.defaults.language = 'ru'

  export default {
    name: 'monthpicker',
    props: {
      value: {
        type: String,
      },
    },
    data () {
      return {
        date: this.valueToDate(this.value),
      }
    },
    watch: {
      value (newValue) {
        this.date = this.valueToDate(newValue)
        this.$nextTick(() => this.$input.datepicker('update'))
      },
      date (newDate) {
        const value = this.dateToValue(newDate)
        if ((!newDate) || (newDate && value)) {
          this.$emit('input', value)
        }
      },
    },
    methods: {
      valueToDate (value) {
        const m = moment(value, 'YYYY-MM', true)
        if (m.isValid()) {
          return m.format('MM.YYYY')
        }
      },
      dateToValue (date) {
        const m = moment(date, 'MM.YYYY', true)
        if (m.isValid()) {
          return m.format('YYYY-MM')
        }
      },
    },
    computed: {
      $input () {
        return $(this.$refs.input)
      },
    },
    mounted () {
      const config = {
        todayHighlight: true,
        autoclose: true,
        minViewMode: 'months',
        format: 'mm.yyyy',
      }
      this.$input.datepicker(config)

      this.$input.on('change clearDate cleared blur', (e) => {
        // Emit native input DOM event so that Vue can catch it
        this.$nextTick(() => eve.emit(this.$refs.input, 'input'))
      })
      this.$input.trigger('change')
    },
    beforeDestroy () {
      this.$input.datepicker('destroy')
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/monthpicker.vue